import React from 'react';
import { Container } from 'components/basics';
import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import Content from 'components/basics/Content';
import SubIntroBackground from 'components/pages/Solution/Marketing/SubIntroBackground';
import { breakpoint } from 'utils/mediaQueries';
import BlockText from './BlockText';
import BlockCase from 'components/pages/ClientCase/CaseBlocks/BlockCase';
import _ from 'lodash';

const GridSubIntro = styled(Grid)`
  ${Content};
  max-width: 1080px;
  padding: 0 2rem;
  padding-bottom: 4rem;
  ${breakpoint.down('lg')`
  padding:1rem 2rem;padding-bottom: 12rem;`};
  ${breakpoint.down('md')`
  padding-bottom: 12rem;`};
  ${breakpoint.down('sm')`
  padding-bottom: 8rem;`};
  ${breakpoint.down('xs')`
  padding-bottom: 10rem;`};
`;
const StyledContainer = styled(Container)`
  padding-top: 2rem;
  ${breakpoint.down('md')`
  padding-top: 0; 
  `}
`;

class IntroBlocks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeChip: 0,
      width: 200,
      heightHeader: 0,
      heightIntro: 0,
      heightTitleIntro: 0,
    };
    this.updateDimensions = this.updateDimensions.bind(this);
  }
  componentDidMount() {
    this.updateDimensions();
    this.handleChipChange(this.props.activeChip);
    window.addEventListener('resize', this.updateDimensions);
  }
  handleStepChange = activeStep => {
    this.setState({ activeStep });
  };
  updateDimensions() {
    const heightNav = document.getElementById('headerNav');
    const heightIntro = document.getElementById('introBlock');
    const heightProblematic = document.getElementById('problematicBlock');
    const heightTitleIntro = document.getElementById('titleIntroBlock');
    this.setState({
      width: window.innerWidth,
      heightHeader: heightNav && heightNav.clientHeight,
      heightIntro: heightIntro && heightIntro.clientHeight,
      heightTitleIntro: heightTitleIntro && heightTitleIntro.clientHeight,
      heightProblematic: heightProblematic && heightProblematic.clientHeight,
    });
  }
  handleChipChange = activeChip => {
    this.setState({ activeChip });
    this.props.callback(activeChip);
  };
  scrollHandler() {
    let anchor = document.getElementById('problematicBlock');
    anchor.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    });
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const heightNav = document.getElementById('headerNav');
    if (heightNav && prevState.heightHeader !== this.state.heightHeader) {
      this.updateDimensions();
    }
  }
  render() {
    const { activeChip } = this.state;
    const widthWindow = this.state.width;
    const heightTitle = this.state.heightTitleIntro + this.state.heightHeader;
    const heightBackground =
      this.state.heightHeader +
      this.state.heightIntro +
      this.state.heightProblematic;
    const filterActive = _.filter(
      this.props.data.chips.nodes,
      array => array.frontmatter.active === true
    );
    return (
      <StyledContainer id="introBlock">
        <GridSubIntro container spacing={24} id="titleIntroBlock">
          <BlockText markdownContent={this.props.data.title} />
        </GridSubIntro>
        <BlockCase
          data={filterActive}
          activeChip={activeChip}
          handleChipChange={cases => this.handleChipChange(cases)}
          scrollHandler={this.scrollHandler}
          widthWindow={widthWindow}
        />
        <SubIntroBackground
          heightBackground={heightBackground}
          widthWindow={widthWindow}
          heightTitle={heightTitle}
        />
      </StyledContainer>
    );
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }
}

export default IntroBlocks;
